import { useNavigate } from '@tanstack/react-router';
import { clearedShopifyListParams, type CampaignSearch } from '../search';
import { SHOPIFY_COUPONS_SEARCH, SHOPIFY_SALES_SEARCH } from './shopifyViews';

/** Moves the campaign page to its Shopify Coupons tab or its Conversions report. */
export function useShopifyCampaignNav() {
  const navigate = useNavigate();
  const goToCoupons = () =>
    void navigate({
      to: '.',
      // Filters and paging from the tab being left must not narrow the Coupons list.
      search: (prev: Partial<CampaignSearch>) => ({
        ...prev,
        ...clearedShopifyListParams(),
        ...SHOPIFY_COUPONS_SEARCH,
        pill: undefined,
        page: undefined,
      }),
    } as never);
  const goToSales = () =>
    void navigate({
      to: '.',
      search: (prev: Partial<CampaignSearch>) => ({ ...prev, ...SHOPIFY_SALES_SEARCH }),
    } as never);
  const goToIntegrationSettings = () =>
    void navigate({
      to: '.',
      search: (prev: Partial<CampaignSearch>) => ({ ...prev, tab: 'settings', sub: 'integrations' }),
    } as never);
  return { goToCoupons, goToSales, goToIntegrationSettings };
}
